<template>
  <div>
    <view-options elementId="SpotifyAds" />
    <div class="product-view" id="SpotifyAds">
      <div>
        <div class="lds-ellipsis" v-if="Product.length === 0">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <ad-goals
          v-bind:totalImpressions="TotalImpressions"
          v-bind:totalClicks="TotalClicks"
          :wording="wordings"
        ></ad-goals>
        <section class="widget brand-impact">
          <h3 class="widget-title">Impacto de su marca en el tiempo</h3>
          <card type="line-chart">
            <div class="card-top">
              <div class="card-header">
                <h4 class="card-title">Impresiones y clicks</h4>
              </div>
            </div>
            <div class="card-content">
              <impressions
                :totalImpressions="Product.totalImpressions || 0"
                :impressions="Product.impressions || []"
                :clicks="Product.clicks || []"
                :imp="impressionsChartOptions"
                :labelType="'Clicks'"
              ></impressions>
            </div>
          </card>
        </section>
      </div>
      <mq-layout mq="laptop+" class="centered">
        <section class="mobile-canvas">
          <img src="@/assets/images/spotify_icon.png" alt />
        </section>
      </mq-layout>
      <section class="widget campaign-widget pb-10">
        <h3 class="widget-title">Métricas de sus anuncios en Spotify</h3>
        <div class="widgets-container">
          <card-metric :metric="TotalCTR" :title="'CTR'" :description="getDefinitions().CTR" :icon="'percent'" />
          <card-metric :metric="TotalCompletes" :title="'Completes'" :description="getDefinitions().COMPLETES" :icon="'check-circle'" />
          <card-metric :metric="TotalSkips" :title="'Skips'" :description="getDefinitions().SKIPS" :icon="'step-forward'" />
          <card-metric :metric="TotalStarts" :title="'Starts'" :description="getDefinitions().STARTS" :icon="'play'" />
        </div>
      </section>
    </div>
    <div class="export" id="export"></div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ViewOptions from "@/components/ViewOptions.vue";
import AdGoals from "@/components/Widgets/AdGoals.vue";
import CardMetric from "../../components/Card/CardMetric.vue";
import Impressions from "@/components/ApexchartCustom/Impressions.vue";

// REQUEST
import { validateProductExpirationDate } from "../../util";
import { ADS_DEFINITIONS } from "../../constants";
import {
  getReportsByDay,
  getSummaryReport
} from "../../services/spotify.service";

export default {
  name: "spotify-ads",
  components: {
    ViewOptions,
    Impressions,
    CardMetric,
    AdGoals
  },
  data() {
    return {
      TotalImpressions: 0,
      TotalClicks: 0,
      TotalCompletes: 0,
      TotalStarts: 0,
      TotalCTR: 0.0,
      TotalSkips: 0,
      ConversionActions: [],
      AllConversionActions: [],
      TotalCampains: {
        Impresiones: 0,
        Clicks: 0,
        CTR: 0,
        CPC: 0,
        Conversions: 0
      },
      TotalLocationCampains: {
        Impresiones: 0,
        Clicks: 0,
        Conversions: 0,
        ConversionRate: 0
      },
      TotalPhoneCalls: 0,
      isAxesa: 0,
      isTrue: false,
      haveAudience: false,
      Product: [],
      PhoneCalls: [],
      ADS: [],
      wordings: {
        Impressions:
          "Cantidad de veces que su publicidad fue expuesta a su público objetivo",
        Clicks: "Interacciones con la audiencia"
      },
      productData: {
        totalImpressions: 0,
        totalClicks: 0
      },
      audienceInteractionSeries: [],
      audienceInteractionChartOptions: {
        colors: [
          "#0A286E",
          "#0E3593",
          "#1248C9",
          "#3772FF",
          "#08ACFF",
          "#93ABE6",
          "#BECDF0"
        ],
        labels: [],
        legend: {
          position: "bottom"
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ]
      },
      keywordDataTotal: {},
      keywordData: [],
      campaignData: [],
      campaignLocationData: [],

      impressionsSeries: [
        {
          name: "Impresiones",
          data: []
        },
        {
          name: "Clicks",
          data: []
        }
      ],
      impressionsChartOptions: {
        tooltip: {
          x: {
            show: true,
            format: "dd MMM",
            formatter: undefined
          },

          y: {
            formatter: function(
              value
              // { series, seriesIndex, dataPointIndex, w }
            ) {
              return value.toLocaleString();
            }
          }
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ],
        chart: {
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          // width: [5, 7, 5],
          curve: "smooth"
        },
        markers: {
          size: 0,

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          categories: []
        },
        grid: {
          borderColor: "#f1f1f1"
        }
      },
      genderSeries: [
        {
          data: []
        }
      ],
      genderChartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      ageSeries: [
        {
          data: []
        }
      ],
      ageChartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      devicesSeries: [
        {
          data: []
        }
      ],
      devicesChartOptions: {
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      adListings: [
        {
          listingIframeUrl:
            "http://caribemediadigital-betaui.azurewebsites.net/Get/Index/70894_16_SD",
          adData: {
            impressions: 1000,
            clicks: 50,
            ctr: 5
          }
        }
      ],
      searchData: {
        calls: 0,
        websiteVisits: 0,
        websiteLinks: []
      }
    };
  },
  watch: {
    date1: {
      handler() {
        this.reload(this);
      },
      deep: true
    },

    date2: {
      handler() {
        this.reload(this);
      },
      deep: true
    }
  },
  async created() {
    const context = this;
    await this.reload(context);
  },
  methods: {
    getDefinitions: function() {
      return ADS_DEFINITIONS;
    },
    reload: async function(context) {
      context.TotalImpressions = 0;
      context.TotalClicks = 0;
      context.TotalStarts = 0;
      context.TotalCTR = 0.0;
      context.TotalCompletes = 0;
      context.TotalSkips = 0;

      context.ageChartOptions.xaxis.categories = [];
      context.genderChartOptions.xaxis.categories = [];
      context.devicesChartOptions.xaxis.categories = [];

      context.campaignData = [];
      context.keywordData = [];
      context.keywordDataTotal = {};

      if (localStorage.getItem("isAxesa") == 1) {
        this.isAxesa = 1;
      }

      const { businessUnitId, productId } = context.$route.params;
      const products = context.$store.state.subscriber.products;
      const { customerId } = context.$route.query;

      const validatedFinalDate = validateProductExpirationDate(products,productId,context.$store.state.subscriber.date1)

      let fromDate = context.$store.state.subscriber.date2 > validatedFinalDate ? validatedFinalDate : context.$store.state.subscriber.date2;
      let toDate = validatedFinalDate;

      const product = {
        clicks: [],
        impressions: [],
        totalImpressions: 0
      };

      const reportData = await getSummaryReport(customerId, businessUnitId, fromDate,toDate);

      context.TotalImpressions = reportData.impressions;
      context.TotalClicks = reportData.clicks;
      context.TotalStarts = reportData.starts;
      context.TotalCTR = reportData.ctr;
      context.TotalCompletes = reportData.completes;
      context.TotalSkips = reportData.skips;

      const reportByDays = await getReportsByDay(customerId,businessUnitId,fromDate,toDate);

      // impressions and clicks
      (reportByDays || []).forEach(element => {
        context.impressionsSeries[0].data.push(element.impressions);
        context.impressionsSeries[1].data.push(element.clicks);
        context.impressionsChartOptions.xaxis.categories.push(element.date);

        product.clicks.push({ count: element.clicks, date: element.date });
        product.impressions.push({
          count: element.impressions,
          date: element.date
        });
      });

      context.Product = product;
    }
  },
  computed: {
    ...mapGetters(["date1", "date2"])
  }
};
</script>
<style lang="scss" scoped>
.export {
  display: none;
}

.centered {
  display: flex;
  justify-content: center;
  align-items: center;
}
.widgets-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}
.pb-10 {
  padding-bottom: 10%;
}
.responsive-table {
  overflow-x: scroll;
}
.ad-data-copy {
  display: grid;
  justify-content: space-evenly;
  align-content: center;
  margin-top: 15px;
  flex-direction: column;
  grid-template-columns: 1fr 1fr 1fr;
  .data {
    margin-bottom: 10px;
    text-align: center;
    &:last-child {
      border-right: 0px;
    }
    h5 {
      color: $highlight-color;
    }
    p {
      font-size: 12px;
    }
  }
}
.google-box-content {
  > img {
    width: 60px;
    margin: 0 auto;
    display: block;
    margin-bottom: 10px;
  }
  .search-box {
    background-color: #fff;
    border-radius: 5px;
    .search-input {
      display: flex;
      justify-content: space-between;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 40px;
      overflow: hidden;
      box-sizing: border-box;
      p {
        font-size: 12px;
        padding: 8px 0px 8px 15px;
        margin-bottom: 0px;
        align-self: flex-start;
        color: $blueish-gray-700;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .search-icon {
        background-color: $google;
        width: 40px;
        height: 36px;
        border-top-right-radius: 5px;
        align-self: flex-end;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .search-options {
      overflow: hidden;
      padding: 0px;
      margin-top: 5px;

      ul {
        display: flex;
        li {
          padding: 5px 10px;
          color: #c0c0c0;
          text-transform: uppercase;
          font-size: 8px;
          font-weight: $font-medium;
          &.active {
            color: $google;
            border-bottom: 2px solid $google;
          }
        }
      }
    }
  }
  .search-results {
    margin-top: 10px;
    padding: 10px;
    background-color: #fff;
    box-shadow: $blueShadow;
    border-radius: 5px;
    max-height: 175px;
    .result-title {
      color: $google;
      margin-bottom: 0px;
      font-size: 12px;
      text-align: left;
    }
    .result-url {
      display: flex;
      align-items: baseline;
      span {
        color: #66c18d;
        padding: 0px 2px;
        border: 1px solid #66c18d;
        border-radius: 5px;
        font-size: 10px;
        margin-right: 5px;
      }
      p {
        color: #66c18d;
        font-size: 10px;
        margin-bottom: 7px;
      }
    }
    .result-separator {
      width: 100%;
      height: 1px;
      background: #e0e0e0;
    }
    .result-description {
      p {
        font-size: 10px;
        margin: 5px 0px 0px 0px;
        text-align: left;
      }
    }
  }
}
.demographic-data {
  h5 {
    font-size: 16px;
    color: $blueish-gray-600;
  }
}

.full-column{
  grid-column: 1 / -1;
}

@include respond-above(ss) {
  .widgets-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .google-box-content {
    max-width: 350px;
    margin: 0 auto;
    > img {
      width: 70px;
    }
    .search-results {
      .result-title {
        font-size: 12px;
      }
      .result-url {
        p {
          font-size: 12px;
        }
      }
      .result-description {
        p {
          font-size: 12px;
        }
      }
    }
  }
}

@include respond-above(md) {
  .widgets-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 10px;
  }
  .product-view {
    display: grid;
    grid-template: 1fr auto / 1fr minmax(300px, 350px);
    grid-column-gap: 30px;
    max-width: 1000px;
    margin: 0 auto;
    .widget-look {
      grid-row: 1 / -1;
      grid-column: 2;
    }
    .widget {
      &.keyword-widget,
      &.campaign-widget {
        grid-column: 1 / -1;
      }
    }
    .separator {
      grid-column: 1 / -1;
      margin-bottom: 20px;
    }
    .demographic-data {
      grid-column: 1 / -1;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 30px;
      & > .widget-title {
        text-align: center;
        grid-column: 1 / -1;
        margin-bottom: 30px;
      }
      .widget:nth-child(4) {
        grid-column: 1 / -1;
      }
    }
    .two-column {
      grid-column: 1 / -1;
    }
    .ad-views {
      grid-column: 1 / -1;
      .cards-wrapper {
        display: grid;
        grid-gap: 30px;
      }
    }
  }
  .google-box-content {
    > img {
      width: 90px;
    }
    .search-box {
      .search-input {
        p {
          font-size: 14px;
        }
      }
      .search-options {
        ul {
          li {
            font-size: 10px;
            padding: 7px 15px;
          }
        }
      }
    }
    .search-results {
      max-height: 145px;
      .result-title {
        font-size: 14px;
      }
    }
  }
}

.two-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  .ad-data {
    ul {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
    }
  }

  .ad-views {
    grid-column: 1 / -1;
    .ad-listing {
      padding: 0;
    }
  }
  .cards-calls-website {
    grid-column: 1 / -1;
  }
}

.ad-data {
  text-align: center;
  h1 {
    font-size: 52px;
    font-weight: 500;
    color: #3576ff;
  }
}

@include respond-above(sm) {
  .two-column {
    .ad-views {
      grid-column: 1;
    }
    .cards-calls-website {
      grid-column: 2;
    }
    .ad-data {
      &.calls {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

// loading

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #3576ff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
</style>
